import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import TechnicalAnalysis,{ THEMES, INTERVALS} from 'react-tradingview-technical-analysis';

class GaugeModal extends Component {
 
componentDidMount(){
    this._isMounted = true;

    
    }
      
componentWillUnmount(){
  this._isMounted = false;
}


constructor(props,context){
    super(props)
    this.state = {

        loading:true,
         
    }

  }
  
    render(){

     // let chart=this.showChart()
     let body= ''
     if(this._isMounted){
       body =   <TechnicalAnalysis 
       symbol={this.props.coinName} 
       interval={TechnicalAnalysis.THEMES.ONE_HOUR,INTERVALS.ONE_WEEK,INTERVALS.ONE_MINUTE}
       colorTheme ={THEMES.DARK}
       autosize ={true}
       height={'100%'}
       width={'100%'} />
     }
       
    return( 
      
      <Modal
        {...this.props}
        size="lg"
        height="200px"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        
      <Modal.Header className="modalpie" closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        <div className="banana3">Gauge</div>
      </Modal.Title>
      </Modal.Header> 
        
      <Modal.Body> 
      <div className="chart">
      
      {body}
    </div>
        <button  className="cancel2 mt-2" title="Cancel" onClick={this.props.onHide}>Close</button>
        
      </Modal.Body>
            
      

      </Modal>
      )
    }

}
export default GaugeModal;